import React from 'react';
import { injectIntl } from 'react-intl';

// Does not actually render anything visible.
// We need it to provide access to internationalization for classes
// which are not a React component
class CurrentLocale extends React.Component {
  static instance = null;

  componentWillMount() {
    if (!CurrentLocale.instance) CurrentLocale.instance = this;
  }

  render() {
    return false;
  }
}

export default injectIntl(CurrentLocale);

export function intl() {
  return CurrentLocale && CurrentLocale.instance && CurrentLocale.instance.props
    ? CurrentLocale.instance.props.intl
    : false;
}

export function formatMessage(...args) {
  return intl().formatMessage(...args);
}



// WEBPACK FOOTER //
// ./src/CurrentLocale.js